// Params sent to server to get sorted lists
export interface SortParams {
  ordering?: string;
}

// Don't work as enum because Object.values would include the keys
export const DIRECTION = {
  ASC: 'asc',
  DESC: 'desc'
} as const;
